module.exports = __webpack_public_path__ + "img/2bc_Events.d40a0f97.png";